export const Subscriptions = {
  BASIC: "BASIC",
  TRANSACTIONAL: "TRANSACTIONAL",
  TRAVELONLY: "TRAVELONLY",
  EAT: "EAT",
  PLAY: "PLAY",
  SHOP: "SHOP",
  TRAVELCATEGORIES: "TRAVELCATEGORIES",
};
